import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

// let dayjs parse and display dates in UTC timezone by default, to avoid issues with local timezones
dayjs.extend(utc);

export const utcDayjs = dayjs;
